export const StrapiEntity = {
  addresses: 'addresses',
  baskets: 'baskets',
  basketItems: 'basket-items',
  gastroMenus: 'gastro-menus',
  gastroFoods: 'gastro-foods',
  gastroCategories: 'gastro-categories',
  regionEvents: 'region-events',
  regionJobs: 'region-jobs',
  regionNews: 'region-all-news',
  regionPosts: 'region-posts',
  regionServices: 'region-services',
  products: 'products',
  shippingRates: 'shipping-rates',
  users: 'users',
  vendors: 'vendors',
  bookmarkCollections: 'bookmark-collections',
  orders: 'orders',
  vendorOrders: 'vendor-orders',
  payouts: 'payouts',
  chatConversations: 'chat-conversations',
  chatMessages: 'chat-messages'
} as const;
